import axios from 'axios';
import axiosRetry from 'axios-retry';

const instance = axios.create({
    baseURL: 'https://joygma.online',
    headers: {
        'Content-Type': 'application/json'
    },
    timeout: 8000 // 全局超时8秒
});

// 自动重试配置（推荐）
// 只对网络错误和超时自动重试2次（共最多请求3次），不重试业务错误
axiosRetry(instance, {
    retries: 2, // 失败后最多重试2次
    retryDelay: axiosRetry.exponentialDelay, // 重试间隔递增（更优雅）
    retryCondition: (error) => {
        // 只重试网络错误和超时，不重试业务报错（如401/500）
        return axiosRetry.isNetworkOrIdempotentRequestError(error) || error.code === 'ECONNABORTED';
    }
});

// 请求拦截器
instance.interceptors.request.use(config => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    // 可选：这里可以加 showLoading()
    return config;
}, error => Promise.reject(error));

// 响应拦截器
instance.interceptors.response.use(
    response => {
        // 可选：这里可以加 hideLoading()
        return response;
    },
    error => {
        // 可选：这里可以加 hideLoading()
        if (error.code === 'ECONNABORTED') {
            window.$toast && window.$toast('网络超时，请重试');
        } else if (error.message && error.message.includes('Network Error')) {
            window.$toast && window.$toast('网络异常，请检查网络');
        } else {
            window.$toast && window.$toast('请求失败，请重试');
        }
        return Promise.reject(error);
    }
);

export default instance;
